import { z } from "zod";
export const FlaggedFeature = z.enum([
    "DisableImporter",
    "VariablesOrder",
    "TypographyPropsKeepAliases",
    "GradientPropsKeepAliases",
    "ShadowPropsKeepAliases",
    "NonCompatibleTypeChanges",
    "TypographyUseFontStyle",
    "SparseCheckoutEnabled",
    "NoTagsNoBlobsCheckoutEnabled",
    "PulsarDebugMode",
    "PulsarLogSdkNetwork",
    "PulsarCacheSdk",
    "PulsarPreloadData",
    "PulsarConcurrencyMode",
    "PulsarConcurrency",
    "PulsarProfilerMode",
    "ForgeE2BTemplate",
    "ForgeOnDemandIterations",
    "ForgeAutoRetryOnErrors",
    "CustomForgeTemplate",
    "ForgeRestartPlaywright",
    "ForgeCopyTemplatePreset",
    "ForgeSandboxTimeout",
    "ForgeFileUploadBatchSize",
    "DSVersionRoomYJSStorageVersion",
    "ForgeTemplateUploadForAll",
    "LargeWorkspaceFileUpload",
    "CliMinimumVersion",
]);
export const FeatureFlagDefaults = {
    DocumentationIgnoreSnapshotsOnPublish: "route-bff+route-p3",
    DSVersionRoomYJSStorageVersion: 1,
};
export const FeatureFlagMap = z.record(FlaggedFeature, z.boolean());
export const FeatureFlag = z.object({
    id: z.string(),
    feature: FlaggedFeature,
    createdAt: z.coerce.date(),
    enabled: z.boolean(),
    designSystemId: z.string().optional(),
    workspaceId: z.string().optional(),
    data: z.record(z.any()).nullable().optional(),
});
